import React, { Component, PropTypes } from 'react'
import URI from 'URIjs'
import { range } from '../utils/array'

export default class Pager extends Component {

  static defaultProps = {
    hash: null
  }

  render() {

    const { count, current, paramName, hash } = this.props
    const pageCount = Math.ceil(count / 30);

    let pageFrom = 0;
    let pageTo = pageCount;

    if (pageCount > 10) {

      pageFrom = current - 4;
      pageTo = current + 6;

      if (pageFrom < 0) {
        pageTo += (pageFrom * -1);
        pageFrom = 0;
      }

      if (pageTo > pageCount) {
        pageTo = pageCount;

        if ((pageTo - pageFrom) != 10)
          pageFrom = pageTo - 10;
      }
    }

    const url = new URI(window.document.location.href)
    const getUrl = (page) => url.clone().setQuery(paramName, page).hash(hash).toString()

    if (pageCount == 1) return null

    return <div className='pal-pager'>

      <span>Psl.:&nbsp;</span>

      {range(pageFrom + 1, pageTo + 1).map(
        i => i != current
          ? <a className='pal-pager-item' key={i} href={getUrl(i)}>{i}</a>
          : <span className='pal-pager-item' key={i}>{i}</span>)}

      {current > 1 ? <span>|&nbsp; <a href={getUrl(current - 1)}>Atgal</a>&nbsp;</span> : null}

      {current != pageCount ? <span>|&nbsp;<a href={getUrl(current + 1)}>Toliau</a>&nbsp;</span> : null}

      <br />

      {current > 4 ? <span><a href={getUrl(1)}>Pirmas puslapis</a></span> : null}

      {current > 4 && pageTo < pageCount ? <span>&nbsp;|&nbsp;</span> : null}

      {pageTo < pageCount ? <span><a href={getUrl(pageCount)}>Paskutinis puslapis</a></span> : null}

    </div>
  }
}